import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MsiRepository } from '@app/domain/ports/tpv/msi.repository';
import { TpvMsiPlan } from '@app/domain/models/tpv/msi.model';
import { MsiPlanDto } from '@app/data/dtos/tpv/msi.dto';
import { mapMsiPlan } from '@app/data/mappers/tpv/msi.mapper';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';
import { toHttpParams } from './tpv-http.util';

/** `GET /api/v1/tpv/msi/`. `id_merchant` obligatorio. Auth vía interceptores estándar. */
@Injectable()
export class MsiRemoteDataSource extends MsiRepository {
  private readonly http = inject(HttpClient);

  override getMsiPlans(externalIdMerchant: string): Observable<TpvMsiPlan[]> {
    const params = toHttpParams({ id_merchant: externalIdMerchant });

    return this.http
      .get<TpvEnvelope<unknown>>(tpvUrl('msi/'), { params })
      .pipe(
        map((raw) => {
          // El back envuelve el listado como `{ msi_available: [...] }`; toleramos
          // también la forma pelada `[...]` y el envelope estándar (`extra_data`/`data`)
          // por si otro entorno la sirve directamente.
          const unwrapped = unwrapTpv<unknown>(raw);
          const list = Array.isArray(unwrapped)
            ? unwrapped
            : (unwrapped && typeof unwrapped === 'object' && Array.isArray((unwrapped as Record<string, unknown>)['msi_available']))
                ? (unwrapped as Record<string, MsiPlanDto[]>)['msi_available']
                : [];
          return list.map(mapMsiPlan);
        }),
      );
  }
}
